import React from 'react';
import { FileText, CheckCircle } from 'lucide-react';
import { SalespersonRequirementTable, BrokerRequirementTable } from '../components/RequirementTables';
export function LicenseInformation() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-993" data-mp="2i2ee7b8ox8t2">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-994" data-mp="2n0g68lo3gigo">
        {/* Page Header */}
        <div className="mb-12" data-id="element-995" data-mp="1pcpbmtgc10pc">
          <div className="flex items-center justify-center mb-6" data-id="element-996" data-mp="1pdh9yc1bdcjb">
            <FileText className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-997" data-mp="1ubsj0kjsbj0h" />
            <h1 className="text-4xl font-bold text-gray-900 text-center" data-id="element-998" data-mp="1uc0v4a832kam">
              LICENSE INFORMATION AND REQUIREMENTS
            </h1>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mb-12 bg-brand-purple-50 rounded-lg p-6 border-2 border-brand-purple-200" data-id="element-999" data-mp="24b9n4xje1ouc">
          <p className="text-lg text-gray-900 mb-4" data-id="element-1000" data-mp="3apr3ht68juq2">
            <strong data-id="element-1001" data-mp="3foc3pslhmeei">License and Course Information:</strong>{' '}
            <a href="/Products" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1002" data-mp="3fqy6lexfo5qe">
              Click here to see On-Demand class offerings
            </a>{' '}
            or{' '}
            <a href="/Login" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1003" data-mp="1wjxcwozw04ne">
              Log In
            </a>
          </p>
        </div>

        {/* Key Information Bullets */}
        <div className="mb-12 space-y-4" data-id="element-1004" data-mp="1hvu2n3eta6ss">
          <div className="flex items-start" data-id="element-1005" data-mp="1hussd15mdoc4">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1006" data-mp="1cwzmk988awcd" />
            <p className="text-base text-gray-700" data-id="element-1007" data-mp="18vnt1sm8hqyw">
              To be paperless: when you click to print your certificate, a PDF
              will be downloaded to your device.
            </p>
          </div>
          <div className="flex items-start" data-id="element-1008" data-mp="yxrkn8kola4h">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1009" data-mp="yysyfkt30apw" />
            <p className="text-base text-gray-700" data-id="element-1010" data-mp="p8ug69mdez6i">
              The Arizona Department of Real Estate:{' '}
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1011" data-mp="uajqfn1rr8tj">
                Fee Schedule
              </a>
            </p>
          </div>
          <div className="flex items-start" data-id="element-1012" data-mp="1cz6uc287ls5j">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1013" data-mp="1cy58r3tkhn9k" />
            <p className="text-base text-gray-700" data-id="element-1014" data-mp="y9iul5fof1jx">
              You must complete and report all your CE credits by midnight of
              the last calendar day of the month that your license expires (that
              includes Saturdays, Sundays and Holidays).
            </p>
          </div>
          <div className="flex items-start" data-id="element-1015" data-mp="1vqzklovw8z9k">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1016" data-mp="1vrsn2dntl2lw" />
            <p className="text-base text-gray-700" data-id="element-1017" data-mp="3gea5zov1sf0i">
              You may pay for and renew your license up to 90 days prior to
              expiration.
            </p>
          </div>
          <div className="flex items-start" data-id="element-1018" data-mp="3q5muc6hn0n1s">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1019" data-mp="3l7bqcce0x6rh" />
            <p className="text-base text-gray-700" data-id="element-1020" data-mp="2xhhdhutpfi78">
              You are responsible for reporting your hours to ADRE and keeping
              your certificates for 5 years.{' '}
              <a href="/How_To_Add_CE_Classes" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1021" data-mp="2skign4inox5c">
                Click here
              </a>{' '}
              for directions and link to ADRE Licensee Login.
            </p>
          </div>
        </div>

        {/* CE Hours REQUIREMENTS */}
        <div className="mb-12" data-id="element-1022" data-mp="hptfdw2yfjmu">
          <h2 className="text-3xl font-bold text-brand-purple-900 mb-6" data-id="element-1023" data-mp="hspidytnsyi5">
            CE Hours REQUIREMENTS
          </h2>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-8" data-id="element-1024" data-mp="1h1l97j5h1nxv">
            <p className="text-base text-gray-800" data-id="element-1025" data-mp="1m1hd7ie65fdf">
              <strong data-id="element-1026" data-mp="1lzmvecy723dk">FIRST TIME RENEWAL:</strong> Be sure to report class
              information from your Pre-Licensing Contract Writing class into
              your account at ADRE. Once done, you will only need 18 additional
              CE hours.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start [&>*]:min-w-0" data-id="element-1027" data-mp="1zzo2wb8ys920">
            {/* Left column: Salesperson table + Elective panel stacked together */}
            <div className="min-w-0 w-full max-w-full" data-id="element-1028" data-mp="29r20uel9p0t1">
              <SalespersonRequirementTable data-id="element-1029" data-mp="29smv033o6hqd" />
              <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg" data-id="element-1030" data-mp="2eqoeuq8x6l2w">
                <p className="text-base text-gray-800 font-medium" data-id="element-1031" data-mp="2jogg4avgfjjr">
                  <strong className="font-bold" data-id="element-1032" data-mp="2jmlqij98n39c">Elective:</strong> For your
                  remaining 3 hours you may choose any credit type, providing
                  you do not duplicate any course title that you have already
                  taken within the renewal period. Different class name =
                  Different course number.
                </p>
              </div>
            </div>

            <BrokerRequirementTable data-id="element-1033" data-mp="qs4dukledffu" />
          </div>
        </div>

        {/* Important Notes */}
        <div className="mb-12 space-y-6" data-id="element-1034" data-mp="lt180xxlf56t">
          <div className="bg-brand-purple-50 border-l-4 border-brand-purple-400 p-6 rounded-lg" data-id="element-1035" data-mp="lu2lf92303rp">
            <p className="text-base text-gray-800" data-id="element-1036" data-mp="h19gak2patf3">
              ADRE allows you to renew your license online. To do so, log on at{' '}
              <a href="https://az.gov/webapp/dre/" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1037" data-mp="c159xmvibf2l">
                https://az.gov/webapp/dre/
              </a>{' '}
              where you will be able to pay for and renew your license.
            </p>
          </div>
        </div>
      </div>
    </div>;
}